import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-radio-input',
    templateUrl: './app-radio-input.component.html',
    styleUrls: ['./app-radio-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: RadioInputComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class RadioInputComponent implements ControlValueAccessor, OnInit, OnChanges, OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() options;
  @Input() title: string = '';
  @Input() default: string = '';
  @Input() addProductPhotoStyles = false;

  ngOnInit(): void {
    this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.value = data.radio_value;
      this.valueChanged(data.radio_value);
    });
  }

  ngOnChanges(): void {
    if (this.default !== '') {
      if (this.default) {
        this.form.setValue({radio_value: this.default});
      }
    }
  }

  form = new FormGroup({
    radio_value: new FormControl(''),
  });

  value;

  onChange = value => {};

  onTouched = () => {};

  touched = false;

  disabled = false;

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  valueChanged(value) {
    this.markAsTouched();
    if (!this.disabled) {
      this.value = value;
      this.onChange(this.value);
    }
  }

  writeValue(value: string) {
    this.value = value;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
